[
    {
        "name": "Hawai'i",
        "title": "Hawaii",
        "telephone": "8087334300",
        "nearbyDistanceMeters": 1300000,
        "mapOptions": {
            "state": "hi",
            "center": { "lat": 20.5, "lng": -157.8 },
            "zoom": 7,
            "maxZoom": 17,

            "mapTypeId": "roadmap"
        }
    },
    {
        "name": "Guam",
        "title": "Guam",
        "telephone": "6714759600",
        "nearbyDistanceMeters": 500000,
        "bbox": { "top": 13.1783003, "left": 144.3605469, "bottom": 13.1940717, "right": 145.2394531 },
        "mapOptions": {
            "state": "gu",
            "center": { "lat": 13.45, "lng": 144.8 },
            "zoom": 10,
            "maxZoom": 17,

            "mapTypeId": "terrain"
        }
    }
]